module.exports = __webpack_public_path__ + "img/cross.aa47d260.svg";